(function () {
  function emailError(raw) {
    var value = raw.trim();
    if (!value) return 'Please enter your email address.';
    var parts = value.split('@');
    if (value.length > 254 || parts.length !== 2) return 'Please enter a valid email address.';
    var local = parts[0], domain = parts[1];
    if (!local || local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..') || !/^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+$/i.test(local)) return 'Please enter a valid email address.';
    var labels = domain.split('.');
    if (domain.length > 253 || labels.length < 2 || labels.some(function (label) { return !/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label); }) || !/^(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})$/i.test(labels[labels.length - 1])) return 'Please enter a valid email address.';
    if (/\.(?:invalid|test|example|localhost)$/i.test(domain) || /^(?:example\.(?:com|net|org)|localhost)$/i.test(domain)) return 'Please enter a real email address that can receive messages.';
    return '';
  }
  function init() {
    var form = document.getElementById('footer_newsletter_signup');
    if (!form || form.dataset.emailValidationReady) return;
    var input = form.querySelector('input[name="contact[email]"]');
    if (!input) return;
    form.dataset.emailValidationReady = 'true';
    var feedback = document.getElementById('footer-newsletter-error');
    var field = input.closest('.footer-email-field');
    var touched = false;
    if (feedback) { form.noValidate = true; input.setAttribute('aria-describedby', feedback.id); }
    function validate(show) {
      var message = emailError(input.value);
      input.setCustomValidity(message);
      if (field) field.classList.toggle('has-email-value', !!input.value.trim());
      var visible = !!message && show;
      input.setAttribute('aria-invalid', visible ? 'true' : 'false');
      if (feedback) {
        feedback.hidden = !visible;
        feedback.querySelector('.footer-newsletter-error__text').textContent = message;
        field.classList.toggle('has-email-error', visible);
      }
      return !message;
    }
    validate(false);
    input.addEventListener('input', function () { validate(touched); });
    input.addEventListener('blur', function () { input.value = input.value.trim(); if (input.value) touched = true; validate(touched); });
    form.addEventListener('submit', function (event) {
      input.value = input.value.trim(); touched = true;
      if (!validate(true)) { event.preventDefault(); if (!feedback) input.reportValidity(); input.focus(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
